export default {
  cog: require('svg-inline!./icons/cog.svg'),
  minus: require('svg-inline!./icons/minus.svg'),
  plus: require('svg-inline!./icons/plus.svg'),
  chevron_up: require('svg-inline!./icons/chevron_up.svg'),
  chevron_right: require('svg-inline!./icons/chevron_right.svg'),
  chevron_down: require('svg-inline!./icons/chevron_down.svg'),
  spinner: require('svg-inline!./icons/spinner.svg'),
  valid: require('svg-inline!./icons/valid.svg'),
  exit: require('svg-inline!./icons/exit.svg'),
  pencil: require('svg-inline!./icons/pencil.svg'),
  trash: require('svg-inline!./icons/trash.svg'),
  ghost: require('svg-inline!./icons/ghost.svg'),
  lock: require('svg-inline!./icons/lock.svg'),
  user: require('svg-inline!./icons/user_circle.svg'),

  facebook: require('svg-inline!./icons/facebook.svg'),
  foursquare: require('svg-inline!./icons/foursquare.svg'),
  twitter: require('svg-inline!./icons/twitter.svg'),
  linkedin: require('svg-inline!./icons/linkedin.svg'),
  google: require('svg-inline!./icons/google.svg'),
  amazon: require('svg-inline!./icons/amazon.svg'),
  angellist: require('svg-inline!./icons/angellist.svg'),
  instagram: require('svg-inline!./icons/instagram.svg'),
  github: require('svg-inline!./icons/github.svg'),
  whatsapp: require('svg-inline!./icons/whatsapp.svg'),
  tumblr: require('svg-inline!./icons/tumblr.svg'),
  meetups: require('svg-inline!./icons/meetups.svg'),
  send: require('svg-inline!./icons/send.svg'),
  email: require('svg-inline!./icons/send.svg')
};



// WEBPACK FOOTER //
// ./src/icons.js